import React from "react";
import {Card, Skeleton, Stack, Typography} from "@mui/material";
import ColletteParagraphSkeleton
  from "@/components/common-controls/collette-paragraph-skeleton/collette-paragraph-skeleton";

const TourCardSkeleton = ({
  testId
}: { testId: string }) => (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        boxShadow: 6,
        borderRadius: "2rem",
        backgroundColor: "background.default",
        maxWidth: "38.6rem",
        minWidth: "25rem",
        width: "100%",
        overflow: "hidden"
      }}
    >
      {/*  Image  */}
      <Skeleton
        variant="rectangular"
        sx={{
          width: "100%",
          objectFit: "cover",
          objectPosition: "center",
          overflow: "hidden",
          height: "204px"
        }}
        data-testid={`${testId}_tour-card-skeleton_hero-image`}
      />
      <Stack sx={{
        padding: "1.6rem",
        gap: "1.6rem"
      }}>

        {/*  Title  */}
        <Typography
          variant="subtitle_lg"
          sx={{
            minHeight: "3lh",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            WebkitLineClamp: 3,
            textOverflow: "ellipsis"
          }}
        >
          <ColletteParagraphSkeleton testId={`${testId}_tour-card-skeleton_title`} numLines={2} />
        </Typography>

        {/*  Travel Styles  */}
        <Skeleton
          variant="rounded"
          height="3.2rem"
          width="10rem"
          sx={{
            borderRadius: "0.8rem"
          }}
          data-testid={`${testId}_tour-card-skeleton_travel-style`}
        />

        {/*  Reviews  */}
        <Skeleton width="80%" data-testid={`${testId}_tour-card-skeleton_rating`} />

        {/*  Pricing  */}
        <Typography
          sx={{
            fontSize: "1.6rem",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "150%"
          }}
        >
          <Skeleton width="80%" data-testid={`${testId}_tour-card-skeleton_price`} />
        </Typography>

        {/*  Days and Activity Level  */}
        <Stack gap="0.8rem" justifyContent="space-between" direction="row" alignItems="center">
          <Skeleton width="50%" data-testid={`${testId}_tour-card-skeleton_number-of-days`} />
          <Skeleton width="50%" data-testid={`${testId}_tour-card-skeleton_activity-level`} />
        </Stack>

        {/*  Tags  */}
        <Typography
          sx={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            WebkitLineClamp: 3,
            textOverflow: "ellipsis",
            fontSize: "1.2rem",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            textWrap: "balance",
            minHeight: "3lh"
          }}
        >
          <ColletteParagraphSkeleton testId={`${testId}_tour-card-skeleton_highlights`} numLines={3} />
        </Typography>

        {/*  Buttons */}
        <Stack direction="row" gap="1.2rem">
          <Skeleton
            variant="rounded"
            sx={{
              width: "50%",
              height: "4rem",
              borderRadius: "25rem"
            }}
            data-testid={`${testId}_tour-card-skeleton_get-a-quote-button`}
          />
          <Skeleton
            variant="rounded"
            sx={{
              width: "50%",
              height: "4rem",
              borderRadius: "25rem"
            }}
            data-testid={`${testId}_tour-card-skeleton_view-tour-button`}
          />
        </Stack>
      </Stack>
    </Card>
  );

export default TourCardSkeleton;